import AbstractPerson from './AbstractPerson'
import Forschungsprojekt from './Forschungsprojekt'
import Publikation from './Publikation'
import ExterneOrganisation from './ExterneOrganisation'
import Foerderung from './Foerderung'
import Person from './Person'
import PersonIdent from './PersonIdent'
import PubIdent from './PubIdent'
import Kooperation from './Kooperation'
import Veranstaltung from './Veranstaltung'
import Patent from './Patent'
import Preis from './Preis'
import Mittelgeber from './Mittelgeber'
import Organisationseinheit from './Organisationseinheit'
import Export from './Export'

/*
BEWARE:

Some of those Validations are functions, currently 'publikation' and 'preis'.
This was done so that the current year get injected into the validation
rule whenever it is imported, i.e. the rule is dynamic.

The downside is that the importing module (components/form/EntityCreateForm.vue)
now has do differentiate between the two possibilities. Ideally, every
validation could be converted into that function type rule but there is
currently no need to do so and the now implemented variant was faster.
*/
export default {
  person: Person,
  abstractPerson: AbstractPerson,
  publikation: Publikation,
  forschungsprojekt: Forschungsprojekt,
  externeOrganisation: ExterneOrganisation,
  foerderung: Foerderung,
  personIdent: PersonIdent,
  pubIdent: PubIdent,
  kooperation: Kooperation,
  veranstaltung: Veranstaltung,
  patent: Patent,
  preis: Preis,
  mittelgeber: Mittelgeber,
  organisationseinheit: Organisationseinheit,
  export: Export
}



// WEBPACK FOOTER //
// ./src/validation/index.js